exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-body-js": () => import("./../../../src/pages/body.js" /* webpackChunkName: "component---src-pages-body-js" */),
  "component---src-pages-head-js": () => import("./../../../src/pages/head.js" /* webpackChunkName: "component---src-pages-head-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

